import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  ADMIN: {
    GET_BUSINESSES: (query) => ({ query }),
    API: {
      GET_BUSINESSES: apiResourceActionCreator('businesses')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}/getBusinesses?${queryString.stringify(query)}`, authToken, action.admin.api.getBusinesses)

function* getBusinesses(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'getBusinesses',
  action: action,
  sagas: getBusinesses,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingBusiness: true
    }),
    success: (state, action) => {
      const newBusinesses = action.payload.businesses.result;
      const updatedBusinessData = (!state.businessData || action.payload.businesses.skip === 0) ?
        action.payload.businesses : {
          ...state.businessData,
          result: state.businessData.result
            .filter((profile) => !newBusinesses.map((newBusiness) => newBusiness.business.id).includes(profile.business.id))
            .concat(newBusinesses)
        }
      return ({
        ...state,
        isFetchingBusiness: false,
        businessData: updatedBusinessData
      })
    },
    failed: (state, action) => ({
      ...state,
      isFetchingBusiness: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/getBusinesses.js